import { Link } from "react-router-dom";
import { CheckCircle2, ArrowRight, Phone, MessageCircle } from "lucide-react";
import { SERVICES, COMPANY } from "../lib/constants";
import CTASection from "../components/sections/CTASection";

const ServicesPage = () => {
  const waLink = `https://wa.me/${COMPANY.whatsapp.replace(/\D/g, "")}`;

  return (
    <main data-testid="services-page" className="bg-white">
      {/* Hero */}
      <section className="pt-32 md:pt-40 pb-16 md:pb-20 bg-slate-50/60 border-b border-slate-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-xs font-semibold uppercase tracking-[0.2em] text-blue-700">
            Our Services
          </div>
          <h1 className="mt-3 font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight font-light text-slate-900 max-w-4xl leading-[1.05]">
            Cleaning that's{" "}
            <span className="font-medium">precise, premium, and personal.</span>
          </h1>
          <p className="mt-5 text-slate-600 max-w-2xl leading-relaxed">
            Every service is delivered by trained, vetted professionals using
            eco-friendly products — so you can step into a space that truly feels new.
          </p>
        </div>
      </section>

      {/* Service blocks */}
      <section className="py-20 md:py-28">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-24">
          {SERVICES.map((s, i) => {
            const reverse = i % 2 === 1;
            return (
              <div
                key={s.slug}
                data-testid={`service-detail-${s.slug}`}
                className={`grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center ${
                  reverse ? "lg:[&>div:first-child]:order-2" : ""
                }`}
              >
                <div className="lg:col-span-6">
                  <div className="rounded-2xl overflow-hidden border border-slate-100 shadow-luxury">
                    <img
                      src={s.image}
                      alt={s.title}
                      className="w-full h-[320px] sm:h-[420px] object-cover"
                      loading="lazy"
                    />
                  </div>
                </div>
                <div className="lg:col-span-6">
                  <div className="text-xs font-semibold uppercase tracking-[0.2em] text-blue-700">
                    {String(i + 1).padStart(2, "0")} · Service
                  </div>
                  <h2 className="mt-3 font-display text-3xl sm:text-4xl tracking-tight font-light text-slate-900">
                    {s.title}
                  </h2>
                  <p className="mt-4 text-slate-600 leading-relaxed">
                    {s.description}
                  </p>
                  <ul className="mt-7 grid sm:grid-cols-2 gap-3">
                    {s.benefits.map((b) => (
                      <li
                        key={b}
                        className="flex items-start gap-2.5 text-sm text-slate-700"
                      >
                        <CheckCircle2 className="w-4 h-4 text-blue-600 mt-0.5 shrink-0" />
                        {b}
                      </li>
                    ))}
                  </ul>
                  <div className="mt-8 flex flex-col sm:flex-row gap-3">
                    <Link
                      to="/contact"
                      data-testid={`service-quote-${s.slug}`}
                      className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md text-sm font-semibold text-white bg-blue-600 hover:bg-blue-700 transition-colors"
                    >
                      Get a Free Quote
                      <ArrowRight className="w-4 h-4" />
                    </Link>
                    <a
                      href={`tel:${COMPANY.phoneClean}`}
                      className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md text-sm font-semibold text-slate-900 border border-slate-200 hover:bg-slate-50"
                    >
                      <Phone className="w-4 h-4" />
                      Call
                    </a>
                    <a
                      href={waLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md text-sm font-semibold text-white bg-[#25D366] hover:bg-[#1EBE5D]"
                    >
                      <MessageCircle className="w-4 h-4" />
                      WhatsApp
                    </a>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </section>

      <CTASection />
    </main>
  );
};

export default ServicesPage;
